import { combineReducers } from 'redux';
import { reducer as modal } from 'redux-modal';

import basic from './basic-reducer';
import account from './account-reducer';
import polkadotAccount from './polkadot-account-reducer';
import kusamaAccount from './kusama-account-reducer';
import OMstake from './om-stake-reducer';
import OMV2stake from './om-v2-stake-reducer';
import OMV3stake from './om-v3-stake-reducer';
import BnbFineStake from './bnb-fine-stake-reducer';
import BnbMistStake from './bnb-mist-stake-reducer';
import BnbCbdStake from './bnb-cbd-stake-reducer';
import BnbBbankStake from './bnb-bbank-stake-reducer';
import BnbMltStake from './bnb-mlt-stake-reducer';
import BnbRosnStake from './bnb-rosn-stake-reducer';
import BondlyWbnbStake from './bondly-wbnb-stake-reducer';
import BnbOmStake from './bnb-om-stake-reducer';
import RAZEstake from './raze-stake-reducer';
import SRFUELstake from './srfuel-stake-reducer';
import BITEstake from './bite-stake-reducer';
import CIRUSstake from './cirus-stake-reducer';
import SKYRIMstake from './skyrim-stake-reducer';
import BCUBEstake from './bcube-stake-reducer';
import SPWNstake from './spwn-stake-reducer';
import LABSGROUPstake from './labs-group-stake-reducer';
import ALPHAstake from './alpha-stake-reducer';
import BONDLYETHstake from './bondly-eth-stake-reducer';
import ROSNstake from './rosn-stake-reducer';
import MLTstake from './mlt-stake-reducer';
import OMBSCstake from './om-bsc-stake-reducer';
import OMPOLYGONstake from './om-polygon-stake-reducer';
import OMETHPOLYGONStake from './om-eth-polygon-stake-reducer';
import GAMERPOLYGONstake from './gamer-polygon-stake-reducer';
import GAMERWETHPOLYGONStake from './gamer-weth-polygon-stake-reducer';
import STFIstake from './stfi-stake-reducer';
import BONDLYBSCstake from './bondly-bsc-stake-reducer';
import PKFstake from './pkf-stake-reducer';
import LABSstake from './labs-stake-reducer';
import L3Pstake from './l3p-stake-reducer';
import ROYAstake from './roya-stake-reducer';
import RFUELstake from './rfuel-stake-reducer';
import UNIstake from './uni-stake-reducer';
import UNIV2stake from './uni-v2-stake-reducer';
import ROYAUNIstake from './roya-uni-stake-reducer';
import RAZEETHUNIstake from './raze-eth-uni-stake-reducer';
import BBANKETHUNIstake from './bbank-eth-uni-stake-reducer';
import BONDLYETHUNIstake from './bondly-eth-uni-stake-reducer';
import BCUBEETHUNIstake from './bcube-eth-uni-stake-reducer';
import ALPHAETHUNIstake from './alpha-eth-uni-stake-reducer';
import BITEETHUNIstake from './bite-eth-uni-stake-reducer';
import ZENUSDTOMETHstake from './zenusdt-om-eth-stake-reducer';
import ZENUSTUNIstake from './zen-ust-uni-stake-reducer';
import ZENWBTCUNIstake from './zen-wbtc-uni-stake-reducer';
import ZENUSDCUNIETHstake from './zenusdc-uni-eth-stake-reducer';
import BITEETHINTERVALSstake from './bite-eth-intervals-stake-reducer';
import BONDLYUSDTUNIstake from './bondly-usdt-uni-stake-reducer';
import LABSUNIstake from './labs-uni-stake-reducer';
import LABSUNISIMPLEstake from './labs-uni-simple-stake-reducer';
import ZENDAIUNIstake from './zen-dai-uni-stake-reducer';
import ZENETHUNIstake from './zen-eth-uni-stake-reducer';
import FXFstake from './fxf-stake-reducer';
import KYLstake from './kyl-stake-reducer';
import STFIWBNBUNIstake from './stfi-wbnb-uni-stake-reducer';
import L3PWBNBUNIstake from './l3p-wbnb-uni-stake-reducer';
import token from './token-reducer';
import history from './history-reducer';
import mantraPool from './mantra-pool-reducer';
import lending from './lending-reducer';
import staking from './staking-reducer';
import delegator from './delegator-rewards-reducer';
import merkleAirdrop from './matic-merkle-airdrop-account-reducer';
import lendingPrices from './lending-prices-reducer';
import lendingMarkets from './lending-markets-reducer';
import lendingLiquidation from './lending-liquidation-reducer';

export default combineReducers({
  modal,
  basic,
  account,
  polkadotAccount,
  kusamaAccount,
  staking,
  OMstake,
  OMV2stake,
  OMV3stake,
  BnbFineStake,
  BnbOmStake,
  BnbMistStake,
  BnbCbdStake,
  BnbBbankStake,
  BnbRosnStake,
  PKFstake,
  LABSstake,
  L3Pstake,
  ROYAstake,
  FXFstake,
  RFUELstake,
  UNIstake,
  UNIV2stake,
  ROYAUNIstake,
  LABSUNIstake,
  LABSUNISIMPLEstake,
  KYLstake,
  RAZEstake,
  SRFUELstake,
  BITEstake,
  CIRUSstake,
  SKYRIMstake,
  BCUBEstake,
  SPWNstake,
  ROSNstake,
  MLTstake,
  OMBSCstake,
  OMPOLYGONstake,
  OMETHPOLYGONStake,
  GAMERPOLYGONstake,
  GAMERWETHPOLYGONStake,
  STFIstake,
  BONDLYBSCstake,
  RAZEETHUNIstake,
  BBANKETHUNIstake,
  BONDLYETHUNIstake,
  BCUBEETHUNIstake,
  BITEETHUNIstake,
  ZENUSDTOMETHstake,
  ZENUSDCUNIETHstake,
  BITEETHINTERVALSstake,
  BONDLYUSDTUNIstake,
  BONDLYETHstake,
  BondlyWbnbStake,
  BnbMltStake,
  token,
  history,
  delegator,
  merkleAirdrop,
  mantraPool,
  lending,
  lendingPrices,
  lendingMarkets,
  lendingLiquidation,
  ALPHAstake,
  ALPHAETHUNIstake,
  LABSGROUPstake,
  ZENDAIUNIstake,
  ZENUSTUNIstake,
  ZENWBTCUNIstake,
  ZENETHUNIstake,
  STFIWBNBUNIstake,
  L3PWBNBUNIstake,
});
